import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { message } from 'antd';
import { RECORD_SOURCE_MESSAGE_KEY } from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/RecordSourceButton/constants/messageKey';
import { cancelPendingDetailPanelListeners } from 'components/RecordsListView/DetailPanel/detailPanelReady';

interface UseDestroyRecordSourceMessageOnNavigationParams {
  enabled?: boolean;
  pathname: string;
}

const useDestroyRecordSourceMessageOnNavigation = ({
  pathname,
  enabled = true
}: UseDestroyRecordSourceMessageOnNavigationParams) => {
  const history = useHistory();

  useEffect(() => {
    if (!enabled) {
      return () => {};
    }

    const unlisten = history.listen((location, action) => {
      if (action !== 'REPLACE' && location.pathname !== pathname) {
        message.destroy(RECORD_SOURCE_MESSAGE_KEY);
        cancelPendingDetailPanelListeners();
      }
    });
    return () => {
      unlisten();
    };
  }, [history, enabled, pathname]);
};

export default useDestroyRecordSourceMessageOnNavigation;
